import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  open(event) {
    event.preventDefault()
    const modalId = event.currentTarget.dataset.modalId
    const modal = document.querySelector(`#${modalId}`)

    if (!modal) {
      console.warn(`[modals] No modal found for id "${modalId}"`)
      return
    }

    this._show(modal)
  }

  openWithFrame(event) {
    event.preventDefault()
    const { modalId, src } = event.currentTarget.dataset
    const modal = document.querySelector(`#${modalId}`)

    if (!modal) {
      console.warn(`[modals] No modal found for id "${modalId}"`)
      if (src) window.location.href = src
      return
    }

    const frame = modal.querySelector('turbo-frame')
    if (frame && src) {
      frame.innerHTML = ''
      frame.src = src
    }

    this._show(modal)
  }

  _show(modal) {
    $(modal).modal('show')
  }
}
